import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { UserCircle } from 'lucide-react-native';
import { useTheme, SPACING, BORDER_RADIUS, FONT_SIZES, TYPOGRAPHY } from '../../theme';
import { Card } from '@components/common';

interface AnonUpgradeBannerProps {
  onUpgrade: () => void;
}

export function AnonUpgradeBanner({ onUpgrade }: AnonUpgradeBannerProps) {
  const { colors } = useTheme();

  return (
    <Card variant="filled" padding="lg" style={styles.upgradeBanner}>
      <View style={styles.upgradeBannerRow}>
        <View
          style={[
            styles.upgradeIcon,
            { backgroundColor: colors.primarySoft, borderColor: colors.primary },
          ]}>
          <UserCircle size={24} color={colors.primary} />
        </View>
        <View style={styles.upgradeText}>
          <Text style={[styles.upgradeTitle, { color: colors.text }]}>
            Save your Fire Scout account
          </Text>
          <Text style={[styles.upgradeBlurb, { color: colors.textSecondary }]}>
            Add an email and password so your posts stay with you across devices. Your existing
            observations keep their attribution.
          </Text>
        </View>
      </View>
      <TouchableOpacity
        style={[styles.upgradeButton, { backgroundColor: colors.action }]}
        onPress={onUpgrade}
        accessibilityRole="button"
        accessibilityLabel="Save your account">
        <Text style={[styles.upgradeButtonText, { color: colors.actionOn }]}>Save my account</Text>
      </TouchableOpacity>
    </Card>
  );
}

const styles = StyleSheet.create({
  upgradeBanner: {
    marginBottom: SPACING.md,
  },
  upgradeBannerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: SPACING.md,
    marginBottom: SPACING.md,
  },
  upgradeIcon: {
    width: 48,
    height: 48,
    borderRadius: BORDER_RADIUS.md,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  upgradeText: {
    flex: 1,
  },
  upgradeTitle: {
    ...TYPOGRAPHY.button,
    fontSize: FONT_SIZES.md,
    marginBottom: 4,
  },
  upgradeBlurb: {
    ...TYPOGRAPHY.bodySmall,
  },
  upgradeButton: {
    paddingVertical: SPACING.smd,
    borderRadius: BORDER_RADIUS.md,
    alignItems: 'center',
  },
  upgradeButtonText: {
    ...TYPOGRAPHY.button,
  },
});
